import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

// Service
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { CommonService } from '../../../../common/service/common.service';

@Component({
	moduleId: module.id,
	selector: 'livestock',
	templateUrl: 'livestock.component.html',
	providers: [
		CommonService
	]
})
export class LiveStockComponent implements OnInit {

	@Input('proposalID') proposalID: string = "";
	@Input('proposalLayout') proposalLayout: number = 0;
	@Input('proposalStatus') proposalStatus: string = "";
	@Input('isProposalRevenue') isProposalRevenue: string = "";
	@Input('proposalRevenueDocument') proposalRevenueDocument: string = "";
	@Input('currentTab') currentTab: string = "";
	@Input('isUserOwner') isUserOwner: boolean = false;

	private token;
	public lives: any[] = [];
	public editLivestockIndex: number = undefined;
	livestock: FormGroup;

	constructor(private fb: FormBuilder, private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService, private commonService: CommonService) {
		this.livestock = fb.group({
			ID: '',
			TipoPecuariaID: ['', Validators.compose([Validators.required])],
			AnoPecuaria: ['', Validators.compose([Validators.required])],
			Quantidade: ['', Validators.compose([Validators.required])],
			Preco: ['', Validators.compose([Validators.required])],
			Despesa: ''
		});
	}

	ngOnInit() {
		this.token = localStorage.getItem('yara.token');
		$("#receitaLiquidaCriacaoAnimais").val(this.getReceitaLiquidaTotal());
		$("#receitaBrutaCriacaoAnimais").val(this.getReceitaBrutaTotal());
		this.getLive();
	}

	setDespesa(e, i) {
		this.percentualCheck(e);
		this.limitFlowProposalService.livestocksObj[i].Despesa = e.target.value;
		$("#receitaLiquidaCriacaoAnimais").val(this.getReceitaLiquidaTotal());
		$("#receitaBrutaCriacaoAnimais").val(this.getReceitaBrutaTotal());
	}

	getReceitaLiquida(i) {
		var porcentagem = parseFloat(this.limitFlowProposalService.livestocksObj[i].Despesa);
		if (porcentagem) {
			return this.getReceitaBruta(i) - this.getReceitaBruta(i) * (porcentagem / 100);
		} else {
			return this.getReceitaBruta(i);
		}
	}

	getReceitaBruta(i) {
		return this.limitFlowProposalService.livestocksObj[i].Quantidade * this.limitFlowProposalService.livestocksObj[i].Preco;
	}

	getReceitaLiquidaTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.livestocksObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.livestocksObj[i].Documento === this.proposalRevenueDocument) {
				sum +=  this.getReceitaLiquida(i);
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.livestocksObj[i].Documento) {
				sum +=  this.getReceitaLiquida(i);
			}
		}

		return sum;
	}

	getReceitaBrutaTotal() {
		let sum = 0;

		for (let i = 0; i < this.limitFlowProposalService.livestocksObj.length; i++) {
			if (this.isProposalRevenue && this.limitFlowProposalService.livestocksObj[i].Documento === this.proposalRevenueDocument) {
				sum +=  this.getReceitaBruta(i);
			} else if (!this.isProposalRevenue && !this.limitFlowProposalService.livestocksObj[i].Documento) {
				sum +=  this.getReceitaBruta(i);
			}
		}

		return sum;
	}

	percentualCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength);
		} else {
			if (e.target.value > 100) {
				e.target.value = 100;
			} else if (e.target.value < 0) {
				e.target.value = 0;
			}
		}
	}

	maxLengthCheck(e) {
		if (e.target.value.length > e.target.maxLength) {
			e.target.value = e.target.value.slice(0, e.target.maxLength)
		}
	}

	getLive() {
		if (this.lives.length === 0) {
			this.limitFlowProposalService.getLive(this.token).subscribe(result => {
				if (result.Success) {
					this.lives = result.Result;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);

			});
		}
	}

	getDescricao(TipoPecuariaID) {
		var desc;
		var item = this.lives.filter(item => item.ID === TipoPecuariaID);
		desc = item[0] ? item[0].Tipo : "";
		return desc;
	}

	saveProposalLive(livestock) {
		livestock.Documento = this.proposalRevenueDocument;
		this.limitFlowProposalService.livestocksObj.push(livestock);
		$("#receitaLiquidaCriacaoAnimais").val(this.getReceitaLiquidaTotal());
		$("#receitaBrutaCriacaoAnimais").val(this.getReceitaBrutaTotal());
		this.flashMessagesService.show("Criação adicionada", { cssClass: 'alert-success', timeout: 6000 });
		this.livestock.reset();
	}

	deleteProposalLive(index) {
		this.limitFlowProposalService.livestocksObj.splice(index, 1);
		$("#receitaLiquidaCriacaoAnimais").val(this.getReceitaLiquidaTotal());
		$("#receitaBrutaCriacaoAnimais").val(this.getReceitaBrutaTotal());
		this.flashMessagesService.show("Criação removida", { cssClass: 'alert-success', timeout: 6000 });
	}

	getProposalLives() {
		if (this.proposalID) {
			this.limitFlowProposalService.getProposalLives(this.token, this.proposalID).subscribe(result => {
				if (result.Success) {
					console.log("this.limitFlowProposalService.livestocksObj", this.limitFlowProposalService.livestocksObj);
					this.limitFlowProposalService.livestocksObj = result.Result;
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);

			});
		}
	}

	editLivestock(index) {
		this.editLivestockIndex = index;
		this.livestock.patchValue({
			TipoPecuariaID: this.limitFlowProposalService.livestocksObj[index].TipoPecuariaID,
			AnoPecuaria: this.limitFlowProposalService.livestocksObj[index].AnoPecuaria,
			Quantidade: this.limitFlowProposalService.livestocksObj[index].Quantidade,
			Preco: this.limitFlowProposalService.livestocksObj[index].Preco,
			Despesa: this.limitFlowProposalService.livestocksObj[index].Despesa
		});
		($(".livestock-list table tbody tr") as any).eq(index).addClass("edit-line");
		($(".livestock-form") as any).addClass("editing");
	}

	saveLivestockEdit() {
		this.limitFlowProposalService.livestocksObj[this.editLivestockIndex].TipoPecuariaID = this.livestock.controls['TipoPecuariaID'].value;
		this.limitFlowProposalService.livestocksObj[this.editLivestockIndex].AnoPecuaria = this.livestock.controls['AnoPecuaria'].value;
		this.limitFlowProposalService.livestocksObj[this.editLivestockIndex].Quantidade = this.livestock.controls['Quantidade'].value;
		this.limitFlowProposalService.livestocksObj[this.editLivestockIndex].Preco = this.livestock.controls['Preco'].value;
		this.limitFlowProposalService.livestocksObj[this.editLivestockIndex].Despesa = this.livestock.controls['Despesa'].value;
		this.editLivestockIndex = undefined;
		this.livestock.reset();
		($(".livestock-list table tbody tr") as any).removeClass("edit-line");
		($(".livestock-form") as any).removeClass("editing");
		$("#receitaLiquidaCriacaoAnimais").val(this.getReceitaLiquidaTotal());
		$("#receitaBrutaCriacaoAnimais").val(this.getReceitaBrutaTotal());
	}

	cancelLivestockEdit() {
		this.editLivestockIndex = undefined;
		($(".livestock-list table tbody tr") as any).removeClass("edit-line");
		($(".livestock-form") as any).removeClass("editing");
		this.livestock.reset();
	}

}






// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/livestock/livestock.component.ts